var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-brandme',{attrs:{"show_modal":_vm.open_modal_login},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('login-container')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }